import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Initialize Firebase first
import "./config/firebase.js";

import { usePageView } from "./hooks/usePageView.js";
import Navbar from "./components/layout/Navbar.jsx";
import Home from "./pages/Home.jsx";
import TimelinePage from "./pages/Timeline.jsx";
import AdminPage from "./pages/Admin.jsx";
import PayPage from "./pages/PayPage.jsx";
import BlogPage from "./pages/BlogPage.jsx";
import BlogPostPage from "./pages/BlogPostPage.jsx";
import "./assets/styles/global.css";

export default function RootLayout() {
  usePageView();

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Navigate to="/#projects" replace />} />
        <Route path="/hackathons" element={<Navigate to="/#hackathons" replace />} />
        <Route path="/certificates" element={<Navigate to="/#certificates" replace />} />
        <Route path="/achievements" element={<Navigate to="/#achievements" replace />} />
        <Route path="/timeline" element={<TimelinePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/pay" element={<PayPage />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <RootLayout />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);
